import i18n from "../../../../../i18n";

export const HOLIDAY_TYPE: any = [
  {
    label: i18n.t("Holiday.type.PublicHoliday"),
    value: "PH",
  },
  {
    label: i18n.t("Holiday.type.EmergencyOff"),
    value: "EO",
  },
];

export const HOLIDAY_TYPE_LIST: any = [
  {
    label: i18n.t("Holiday.type.PublicHoliday"),
    value: "PH",
  },
  {
    label: i18n.t("Holiday.type.PublicHoliday"),
    value: "Public Holiday",
  },
  {
    label: i18n.t("Holiday.type.EmergencyOff"),
    value: "EO",
  },
  {
    label: i18n.t("Holiday.type.EmergencyOff"),
    value: "Emergency Off",
  },
];

export const HOLIDAY_COUNTRIES_LIST: any = [
  {
    label: "Mauritius",
    value: "MU",
  },
  {
    label: "Singapore",
    value: "SG",
  },
  {
    label: "Malaysia",
    value: "MY",
  },
  {
    label: "Japan",
    value: "JP",
  },
  {
    label: "Hong Kong",
    value: "HK",
  },
  {
    label: "United Kingdom",
    value: "GB",
  },
];

export const DateComparisionOperators = {
  LessThanToday: "LessThanToday",
  LessThanOrEqualsToToday: "LessThanOrEqualsToToday",
  EqualsToToday: "EqualsToToday",
  GreaterThanToday: "GreaterThanToday",
  GreaterThanOrEqualsToToday: "GreaterThanOrEqualsToToday",
};

export const holidayTypes = {
  EO: "EO",
  PH: "PH",
  PUBLIC_HOLIDAY: "Public Holiday",
  EMERGENCY_OFF: "Emergency Off",
};
export const holidayNameTypes: any = {
  EO: i18n.t("Holiday.type.EmergencyOff"),
  PH: i18n.t("Holiday.type.PublicHoliday"),
  PUBLIC_HOLIDAY: i18n.t("Holiday.type.PublicHoliday"),
  EMERGENCY_OFF: i18n.t("Holiday.type.EmergencyOff"),
};

/*export const requiredColumns = [
  'CountryCode',
  'Date',
  'Holiday',
  'HolidayType',
  'IsActive',
  'isSentEmail',
];*/

export const requiredColumns = [
  "Holiday Name",
  "Type",
  "Date",
  "Day",
  "PG Entity",
];

export const uploadFileExtension = ".xls,.xlsx";
